import React from 'react';

import WsIconProps from './IconProps';

const UsersRound: React.FC<WsIconProps> = ({ color = '#0D2E36', width = 20, height = 18 }) => (
  <svg
    width={width}
    height={height}
    viewBox={`0 0 ${width} ${height}`}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M15 16.5C15 14.7319 14.2976 13.0362 13.0474 11.786C11.7971 10.5357 10.1014 9.83333 8.33332 9.83333M8.33332 9.83333C6.56521 9.83333 4.86952 10.5357 3.61928 11.786C2.36904 13.0362 1.66666 14.7319 1.66666 16.5M8.33332 9.83333C10.6345 9.83333 12.5 7.96785 12.5 5.66667C12.5 3.36548 10.6345 1.5 8.33332 1.5C6.03214 1.5 4.16666 3.36548 4.16666 5.66667C4.16666 7.96785 6.03214 9.83333 8.33332 9.83333ZM18.3333 15.6668C18.3333 12.8585 16.6666 10.2502 15 9.00016C15.5478 8.58914 15.9859 8.0494 16.2755 7.42872C16.565 6.80804 16.6971 6.12555 16.66 5.44166C16.6229 4.75777 16.4178 4.09357 16.0629 3.50783C15.7079 2.92209 15.2141 2.43288 14.625 2.0835"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default UsersRound;
